export default __webpack_public_path__ + "static/media/RussellsFarm.0cb990b2.png";